export interface SearchResult {
  uid: string;
  name: string;
  type?: string; // for reports
  itemType: string;
  workspace_id: number;
}

export enum SearchType {
  NOTEBOOK = 'notebook',
  REPORT = 'report',
  TABLEAU_EMBED = 'tableau_embed',
}
